export default __webpack_public_path__ + "static/media/category2.a96e9cb9.png";